module.exports = __webpack_public_path__ + "static/assets/444c8bb71110255afdf20f68c4768eb3.png";